// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"135":"052709487ad2c09c","264":"caf2a9128b13abd1","272":"3efbafd7b86c4904","309":"70886c33a15bf633","606":"07aa58b989c4cf05","733":"70b77a5d3974aca9","952":"880b88d7c30c5b32"}[chunkId] + ".js";
};